const data = [{
		id: '1',
		name: '首页',
		icon: 'el-icon-s-home',
		path: '/adminIndex',
		children: [
			{
				id: '1-1',
				name: '权限管理',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/authority/',
				children: [
					{
						id: '1-1-1',
						name: '用户管理',
						// path: '/admin/authority/userindex'
						path: '/adminIndex/userindex'
					},
					// {
					// 	id: '1-1-3',
					// 	name: '日志管理',
					// 	path: '/admin/authority/loggerindex'
					// }
				]
			},
			{
				id: '1-4',
				name: '资讯管理',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/news/',
				children: [
					{
						id: '1-4-1',
						name: '资讯管理',
						path: '/adminIndex/articleindex'
					},
				]
			},
			{
				id: '1-6',
				name: '业务管理',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/service/',
				children: [
					{
						id: '1-6-1',
						name: '业务管理',
						path: '/adminIndex/serviceindex'
					},
				]
			},
			{
				id: '1-7',
				name: '律师管理',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/lawyer/',
				children: [
					{
						id: '1-7-1',
						name: '律师管理',
						path: '/adminIndex/lawyerindex'
					},
				]
			},
			{
				id: '1-8',
				name: '和华文化',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/culture/',
				children: [
					{
						id: '1-8-1',
						name: '和华文化',
						path: '/adminIndex/cultureindex'
					},
				]
			},
			{
				id: '1-9',
				name: '留言管理',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/leaveMassage/',
				children: [
					{
						id: '1-9-1',
						name: '留言管理',
						path: '/adminIndex/leaveMassageindex'
					},
				]
			},
			{
				id: '1-10',
				name: '关于我们',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/aboutUs/',
				children: [
					{
						id: '1-10-1',
						name: '红色建设',
						path: '/adminIndex/aboutUsindex'
					},
				]
			},
			{
				id: '1-11',
				name: '加入我们',
				icon: 'el-icon-caret-right',
				path: '/adminIndex/joinUs/',
				children: [
					{
						id: '1-11-1',
						name: '招聘管理',
						path: '/adminIndex/joinUsindex'
					},
				]
			},
			// {
			// 	id: '1-2',
			// 	name: '内容管理',
			// 	icon: 'el-icon-caret-right',
			// 	path: '/admin/content/',
			// 	children: [
			// 		{
			// 			id: '1-2-1',
			// 			name: '栏目管理',
			// 			path: '/admin/content/channelindex'
			// 		},
			// 		{
			// 			id: '1-2-2',
			// 			name: '轮播图管理',
			// 			path: '/admin/content/SlideshowIndex'
			// 		},
			// 		// {
			// 		// 	id: '1-2-4',
			// 		// 	name: '标签管理',
			// 		// 	path: '/admin/content/TagIndex'
			// 		// }
			// 	]
			// },
			// {
			// 	id: '1-3',
			// 	name: '业务管理',
			// 	icon: 'el-icon-caret-right',
			// 	path: '/admin/business/',
			// 	children: [
			// 		{
			// 			id: '1-3-1',
			// 			name: '业务景区',
			// 			path: '/admin/business/scenicindex'
			// 		},
			// 		{
			// 			id: '1-3-2',
			// 			name: '软件成果',
			// 			path: '/admin/business/softwareindex'
			// 		}
			// 	]
			// },
			// {
			// 	id: '1-5',
			// 	name: '招聘管理',
			// 	icon: 'el-icon-caret-right',
			// 	path: '/admin/recruit/',
			// 	children: [
			// 		{
			// 			id: '1-5-1',
			// 			name: '岗位管理',
			// 			path: '/admin/recruit/recruitindex'
			// 		}
			// 	]
			// },
		]
	}

]

export default data
